<template>
      <div class="fright  cright" >
          <a-row :gutter="1" >
            <a-col :span="13"  v-for="item in data" :key="item.id" >
                <div class="qlist">
                  <div class="wh3">
                    <img src="../../images/ask.png" alt="" class="fleft w">
                    <h3 class="fleft ml10">{{item.asktitle}}</h3>
                  </div>
                  <div class="clear"></div>
                  <div class="anwer">
                    <img src="../../images/answer.png" alt="" class="fleft d">
                    <div class="fleft anwerC" v-html="item.reply">
                    </div>
                  </div>
                </div>
            </a-col>
          </a-row>
        <!--</div>-->
        <div class="fy" v-if="data.length>0">
          <span style="margin-top:4px;margin-right:5px">共&nbsp;{{total}}&nbsp;条记录</span>
          <div class="fir"><a @click="btnfir" :disabled="disabled" ref="fa">首页</a></div>
          <a-config-provider :locale="locale">
            <a-pagination  :total="ipagination.total" :item-render="itemRender" :pagination="ipagination" :defaultPageSize="ipagination.pageSize"
                           v-model="ipagination.pageNo" @change='changePage'>
            </a-pagination>
          </a-config-provider>
          <div class="end"><a ref="end" :disabled="disablede" @click="endbtn">末页</a></div>
          <span style="margin-left:5px">跳至&nbsp;<a-input type="text" v-model="text" @blur="changeText" style="width:50px;border:normal" />&nbsp;页</span>
        </div>
      </div>

</template>



<script>
import http from '../../js/axios'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
  name: 'AquaticZixun',
  components: {
  },
  data(){
    return{
      disabled:false,
      disablede:false,
      locale: zhCN,
      ipagination:{
        current: 1,
        pageNo:1,
        pageSize: 5,
        pageSizeOptions: ['5', '10', '20'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      treeList: [
      ],
      openKeys: [],
      openKeys1:[],
      data:[],
      default:[],
      id:'',
      total:0,
      text:null,
    }
  },
  computed:{},
  created(){
    this.queryZx()
    // let a = this.$route.params.sczt
    // this.querytree(a)
    if(this.ipagination.total=='0'){
      this.disablede = true
      this.disabled = true
    }
  },
  mounted () {

  },
  watch: {
    openKeys(val) {
    },
    ipagination: {
      handler(newVal) {
        setTimeout(() => {
          if(newVal.pageNo=='1'){
            this.disabled = true
            this.$refs.fa.style.color = '#bfbfbf'
          }else{
            this.disabled = false
            this.$refs.fa.style.color = '#595959'
          }
          let end = newVal.total/newVal.pageSize
          end = Math.ceil(end)
          if(newVal.current!=end){
            this.disablede = false
            this.$refs.end.style.color = '#595959'
          }else{
            this.$refs.end.style.color = '#bfbfbf'
            this.disablede = true
          }
        }, 50);
      },
      deep: true
    }
  },
  methods: {
    changeText(e){
      var i = parseInt(e.target.value)
      let end = this.total/this.ipagination.pageSize
      end = Math.ceil(end)
      if(i>end){
        this.ipagination.current = end
        this.ipagination.pageNo = end
        this.text = null
      }else if(i==0){
        this.ipagination.current = 1
        this.ipagination.pageNo = 1
        this.text = null
      }else if(e.target.value==null || e.target.value==''){

      }
      else{
        this.ipagination.current = i
        this.ipagination.pageNo = i
        this.text = i
      }
      this.queryZx(this.id)

    },

    endbtn(){
      if(this.text!=null){
        this.text=null
      }
      let end = this.ipagination.total/this.ipagination.pageSize
      end = Math.ceil(end)
      this.ipagination.pageNo = end
      this.queryZx(this.id)
    },
    btnfir(){
      if(this.text!=null){
        this.text=null
      }
      this.ipagination.pageNo = 1
      this.queryZx(this.id)
    },
    changePage(e){
      if(this.text!=null){
        this.text=null
      }
      this.ipagination.pageNo = e
      this.queryZx(this.id)
    },
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return <div class="pre"><a>上一页</a></div>;
      } else if (type === 'next') {
        return <div class="next"><a>下一页</a></div>;
      }
      return originalElement;
    },
    customRow(record, index) {
      return {
        style: {
          // 行背景色
          'background-color': index % 2 == 0 ? '#FFFFFF' : '#eff2f4',
        }
      }
    },
    handleEdit(){

    },
    handleAddSub(){},
    handleClick(e) {
      if(this.text!=null){
        this.text=null
      }
      if(this.ipagination.pageNo!=1){
        this.ipagination.pageNo=1
      }
      this.id = e.key
      this.queryZx(e.key)
    },
    queryZx(){
      http.get('/queryZxlist',{params:{pageNo:this.ipagination.pageNo}}
      ).then((res) => {
        this.data = res.data.result.records
        this.ipagination.total = res.data.result.total
        this.ipagination.current = res.data.result.current
        this.total = res.data.result.total
        this.scwh=res.data.result
      })
    },
    querytree(value){
      http.post(
        '/ztfw-type-all',{}
      ).then((res) => {
        this.treeList = res.data.data
        let data = []
        this.openKeys = []
        for(var a = 0;a<this.treeList.length;a++){
          if(this.openKeys1!=[] && value==this.treeList[a].label){
            data.push(this.treeList[a].id)
            this.openKeys = data
            this.openKeys1.push(this.treeList[a].children[0].id)
            this.id=this.treeList[a].children[0].id
            break
          }else{
            this.openKeys.push(this.treeList[0].id)
            this.openKeys1.push(this.treeList[0].children[0].id)
            this.id=this.treeList[0].children[0].id
          }
        }
        this.queryZx(this.id)
      })
    },
  },
}
</script>


<style scoped>
@import "../../config/AquaticZixun.css"

</style>







// WEBPACK FOOTER //
// src/views/aquaticzixun/AquaticZixun.vue